import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectLoader = (state) => state.loader || initialState;

const loaderSelector = () =>
  createSelector(selectLoader, (state) => state.loader);

export { loaderSelector };
